<style>
    .scoreBar {
        vertical-align: middle;
        height: 1.5em;
        width: 1.5em;
    }

    .average {
        text-align: center;
    }

    .gauge {
        margin-top: 1em;
    }

    .red1 {
        background-color: rgba(220, 57, 18, 0.3);
    }

    .yellow1 {
        background-color: #f4fe9273;
    }

    .red2 {
        background-color: rgba(220, 57, 18, 0.1);
    }

    .gray {
        background-color:#E8E8E8;
    }

    .green1 {
        background-color: rgba(76, 175, 80, 0.2);
    }

    .green2 {
        background-color: rgba(76, 175, 80, 0.4);
    }

    .green3 {
        background-color: rgba(76, 175, 80, 0.6);
    }

    .green4 {
        background-color: rgba(76, 175, 80, 0.8);
    }


    .white2 {
        background-color: white;
    }

    .difference-one-up {
        background-color: rgba(152, 133, 189, 0.4);
    }

    .difference-two-up {
        background-color: rgba(152, 133, 189, 0.6);
    }

    .difference-more-up {
        background-color: rgba(152, 133, 189, 0.8);
    }


    .difference-one-down {
        background-color: rgba(108, 144, 172, 0.4);
    }

    .difference-two-down {
        background-color: rgba(108, 144, 172, 0.6);
    }

    .difference-more-down {
        background-color: rgba(108, 144, 172, 0.8);
    }

    .main text {
        font: 9px sans-serif;	
    }

    .axis line, .axis path {
        shape-rendering: crispEdges;
        stroke: black;
        fill: none;
    }

    .scores {
       border: solid 1px; border-color: #dcd3d3;
    }

    .subtitle {
        border: solid 1px;
        border-color: #dcd3d3;
        max-width: 5em !important;
        text-align: center;
        padding: 0 !important;
    }
    
    .score {
        text-align: center;
        border: solid 1px;
        border-color: #dcd3d3;
        max-width: 4em !important;
    }

    .v-expansion-panel__header {
        text-align: center;
        vertical-align: middle;
        margin-bottom: 1em;
        margin-top: 1em;
    }

    .radialGauge {
        max-height: 10em;
        max-width: 10em;
        margin-left: 3em;
    }

    .radialGauge > svg {
        height: 10em;
        width: 10em;
    }

    .rbc-center-text {
        font-weight: bold;
        font-size: 2em;
    }
 
    .teacher-score {
        color: rgb(79, 220, 103);
        font-weight: bold;
        text-align: center;
    }

    .student-score {
        color: rgb(42, 205, 203);
        font-weight: bold;
        text-align: center;
    }

    .empty {
        border-top: solid 1px white;
        border-bottom: solid 1px white;
        padding: 1em 1em 1em !important;
        max-width: 4em !important;
    }

    .class-container {
        max-width: 12em !important;
    }

    .v-btn.v-btn--active { 
        background-color: #C6D5C6 !important; 
        color: green !important;
    }

    .period-buttons-container {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        text-align: center;
    }

    .reporting-period {
        text-align: center;
        width: 100% !important;
    }
</style>


<template>
    <v-card>
        <v-toolbar class="elevation1">
            <v-toolbar-title>Student Dashboard: {{ studentName }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <dashboard-data-downloader 
                :studentId="this.$route.params.studentId"
            ></dashboard-data-downloader>
        </v-toolbar>
        <v-alert v-model="noDataNotification" icon="warning" outline>
            The selected student has no data to display
        </v-alert>
        <v-layout row wrap style="padding-top: 20px" v-if="hasData">
            <v-flex xs5 class="average">
                <div id="effort-container">
                    <svg id="averageControl" height="200"></svg>
                </div>
                <h3>Effort</h3>
                <h4>Student Graded Score:  {{ studentEffortScore }}</h4>
            </v-flex>
            <v-flex xs7 class="gauge">
                <v-layout row wrap>
                    <v-flex xs4 text-xs-center>
                        <v-layout row wrap>
                            <div class="radialGauge" id="radialDiligence"></div>
                        </v-layout>
                        <div row wrap>
                            <span class="teacher-score">Teacher: {{ teacherDiligenceScore }}</span>
                        </div>
                        <div row wrap>
                            <span class="student-score">Student: {{ studentDiligenceScore }}</span>
                        </div>
                    </v-flex>
                    <v-flex xs4 text-xs-center>
                        <v-layout row>
                            <div class="radialGauge" id="radialEngagement"></div>
                        </v-layout>
                        <div row wrap>
                            <span class="teacher-score">Teacher: {{ teacherEngagementScore }}</span> <br>
                        </div>
                        <div row wrap>
                            <span class="student-score">Student: {{ studentEngagementScore }}</span>
                        </div>
                    </v-flex>
                    <v-flex xs4 text-xs-center>
                        <v-layout row wrap>
                            <div class="radialGauge" id="radialBehaviour"></div>
                        </v-layout>
                        <div row wrap>
                            <span class="teacher-score">Teacher: {{ teacherbehaviourScore }}</span> <br>
                        </div>
                        <div row wrap>
                            <span class="student-score">Student: {{ studentBehaviourScore }}</span>
                        </div>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
        <br>
        <br>
        <v-layout row wrap v-if="hasData" class="period-buttons-container">
            <v-btn-toggle v-model="dashboardPeriodId" mandatory style="width: 100% !important">
                <div class="reporting-period">
                    <v-btn v-for="rp in completeReportingPeriods" :key="rp.id" :value="rp.id"
                            style="margin: 0.5em;" >
                        <v-icon>history</v-icon>
                        <span>{{ rp.name }} </span>
                    </v-btn>
                </div>
                
            </v-btn-toggle>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </v-layout>
        <br>
        <v-layout row wrap v-if="hasData">
            <v-expansion-panel expand primary>
                <v-expansion-panel-content v-model="showTables">
                    <div slot="header" justify-center >
                        <v-btn large outline color="primary">DIG DEEPER</v-btn>
                        <v-btn large outline color="primary" :to="{ name: 'StudentMotionChart', params: { studentId: this.$route.params.studentId }}">BUBBLE CHART</v-btn>
                    </div>
                    <div class="v-table__overflow">
                        <table class="v-datatable v-table dashboardTable">
                            <thead>
                                <tr>
                                    <th rowspan="2" colspan="2" class="scores">Classes</th>
                                    <th class="empty"></th>
                                    <th colspan="4" class="scores">Teacher Graded</th>
                                    <th class="empty"></th>
                                    <th colspan="4" class="scores">Student Graded</th>
                                    <th class="empty"></th>
                                    <th colspan="3" class="scores">Differences</th>
                                    <th class="empty"></th>
                                </tr>
                                <tr>
                                    <th class="empty"></th>
                                    <th class="subtitle">{{diligenceLabel}}</th>
                                    <th class="subtitle">{{engagementLabel}}</th>
                                    <th class="subtitle">{{behaviourLabel}}</th>
                                    <th class="subtitle">Score</th>
                                    <th class="empty"></th>
                                    <th class="subtitle">{{diligenceLabel}}</th>
                                    <th class="subtitle">{{engagementLabel}}</th>
                                    <th class="subtitle">{{behaviourLabel}}</th>
                                    <th class="subtitle">Score</th>
                                    <th class="empty"></th>
                                    <th class="subtitle">{{diligenceLabel}}</th>
                                    <th class="subtitle">{{engagementLabel}}</th>
                                    <th class="subtitle">{{behaviourLabel}}</th>
                                    <th class="empty"></th>
                                    <!-- <th class="subtitle">Score</th> -->
                                </tr>
                            </thead>
                            <tbody>
                                
                                <tr v-for="item in gradeItems" :key="item.classId" text-sm-center>
                                    <td class="scores class-container">{{ item.name }}</td>
                                    <td class="scores class-container">{{ item.teacher }}</td>
                                    <td class="empty"></td>

                                    <!-- TEACHER GRADED -->
                                    <td v-bind:class="{ 'score': true,
                                        'gray': item.teacherGradedDiligence == 0,
                                        'yellow1': item.teacherGradedDiligence == 1,  
                                        'white2': item.teacherGradedDiligence == 2,
                                        'green2': item.teacherGradedDiligence == 3,
                                        'green3': item.teacherGradedDiligence == 4,
                                        'green4': item.teacherGradedDiligence == 5 }">                                

                                        <!-- <img class="scoreBar" v-if="item.teacherGradedDiligence == 0" src="baseline_signal_cellular_0_bar_black_18dp.png">     -->
                                        <img class="scoreBar" v-if="item.teacherGradedDiligence == 1" src="baseline_signal_cellular_0_bar_black_18dp.png">    
                                        <img class="scoreBar" v-if="item.teacherGradedDiligence == 2" src="baseline_signal_cellular_1_bar_black_18dp.png">
                                        <img class="scoreBar" v-if="item.teacherGradedDiligence == 3" src="baseline_signal_cellular_2_bar_black_18dp.png">
                                        <img class="scoreBar" v-if="item.teacherGradedDiligence == 4" src="baseline_signal_cellular_3_bar_black_18dp.png">
                                        <img class="scoreBar" v-if="item.teacherGradedDiligence == 5" src="baseline_signal_cellular_4_bar_black_18dp.png">

                                        <div v-if="item.teacherGradedDiligence != 0">{{ item.teacherGradedDiligence  }}</div>
                                    </td>

                                    <td v-bind:class="{ 'score': true,
                                        'gray': item.teacherGradedEngagement == 0,
                                        'yellow1': item.teacherGradedEngagement == 1,  
                                        'white2': item.teacherGradedEngagement == 2,
                                        'green2': item.teacherGradedEngagement == 3,
                                        'green3': item.teacherGradedEngagement == 4,
                                        'green4': item.teacherGradedEngagement == 5 }">

                                        <!-- <img class="scoreBar" v-if="item.teacherGradedEngagement == 0" src="baseline_signal_cellular_0_bar_black_18dp.png">     -->
                                        <img class="scoreBar" v-if="item.teacherGradedEngagement == 1" src="baseline_signal_cellular_0_bar_black_18dp.png">    
                                        <img class="scoreBar" v-if="item.teacherGradedEngagement == 2" src="baseline_signal_cellular_1_bar_black_18dp.png">
                                        <img class="scoreBar" v-if="item.teacherGradedEngagement == 3" src="baseline_signal_cellular_2_bar_black_18dp.png">
                                        <img class="scoreBar" v-if="item.teacherGradedEngagement == 4" src="baseline_signal_cellular_3_bar_black_18dp.png">
                                        <img class="scoreBar" v-if="item.teacherGradedEngagement == 5" src="baseline_signal_cellular_4_bar_black_18dp.png">
                                    
                                        <div v-if="item.teacherGradedEngagement != 0">{{ item.teacherGradedEngagement }}</div> 
                                    </td>

                                    <td v-bind:class="{ 'score': true,
                                        'gray': item.teacherGradedBehaviour == 0,
                                        'yellow1': item.teacherGradedBehaviour == 1,  
                                        'white2': item.teacherGradedBehaviour == 2,
                                        'green2': item.teacherGradedBehaviour == 3,
                                        'green3': item.teacherGradedBehaviour == 4,
                                        'green4': item.teacherGradedBehaviour == 5 }">

                                        <!-- <img class="scoreBar" v-if="item.teacherGradedBehaviour == 0" src="baseline_signal_cellular_0_bar_black_18dp.png">     -->
                                        <img class="scoreBar" v-if="item.teacherGradedBehaviour == 1" src="baseline_signal_cellular_0_bar_black_18dp.png">    
                                        <img class="scoreBar" v-if="item.teacherGradedBehaviour == 2" src="baseline_signal_cellular_1_bar_black_18dp.png">
                                        <img class="scoreBar" v-if="item.teacherGradedBehaviour == 3" src="baseline_signal_cellular_2_bar_black_18dp.png">
                                        <img class="scoreBar" v-if="item.teacherGradedBehaviour == 4" src="baseline_signal_cellular_3_bar_black_18dp.png">
                                        <img class="scoreBar" v-if="item.teacherGradedBehaviour == 5" src="baseline_signal_cellular_4_bar_black_18dp.png">

                                        <div v-if="item.teacherGradedBehaviour != 0">{{ item.teacherGradedBehaviour }}</div>
                                    
                                    </td>

                                    
                                    <td v-bind:class="{ 'score': true,
                                        'gray': item.teacherGradedScore == 0,
                                        'green1': item.teacherGradedScore >= 61 && item.teacherGradedScore <= 70,
                                        'green2': item.teacherGradedScore >= 71 && item.teacherGradedScore <= 80,
                                        'green3': item.teacherGradedScore >= 81 && item.teacherGradedScore <= 90,
                                        'green4': item.teacherGradedScore >= 91,
                                    }">

                                    <div v-if="item.teacherGradedScore > 0">{{ item.teacherGradedScore }}</div>
                                    </td>

                                    <td class="empty"></td>

                                    <!-- STUDENT GRADED -->
                                    <td v-bind:class="{ 'score': true, 
                                        'gray': item.studentGradedDiligence == 0,
                                        'yellow1': item.studentGradedDiligence == 1,  
                                        'white2': item.studentGradedDiligence == 2,
                                        'green2': item.studentGradedDiligence == 3,
                                        'green3': item.studentGradedDiligence == 4,
                                        'green4': item.studentGradedDiligence == 5 }"
                                    >

                                        <!-- <img class="scoreBar" v-if="item.studentGradedDiligence == 0" src="baseline_signal_cellular_0_bar_black_18dp.png">     -->
                                        <img class="scoreBar" v-if="item.studentGradedDiligence == 1" src="baseline_signal_cellular_0_bar_black_18dp.png">    
                                        <img class="scoreBar" v-if="item.studentGradedDiligence == 2" src="baseline_signal_cellular_1_bar_black_18dp.png">
                                        <img class="scoreBar" v-if="item.studentGradedDiligence == 3" src="baseline_signal_cellular_2_bar_black_18dp.png">
                                        <img class="scoreBar" v-if="item.studentGradedDiligence == 4" src="baseline_signal_cellular_3_bar_black_18dp.png">
                                        <img class="scoreBar" v-if="item.studentGradedDiligence == 5" src="baseline_signal_cellular_4_bar_black_18dp.png">

                                    <div v-if="item.studentGradedDiligence != 0">{{ item.studentGradedDiligence }}</div> 
                                    </td>

                                    <td v-bind:class="{ 'score': true, 
                                        'gray': item.studentGradedEngagement == 0,
                                        'yellow1': item.studentGradedEngagement == 1,  
                                        'white2': item.studentGradedEngagement == 2,
                                        'green2': item.studentGradedEngagement == 3,
                                        'green3': item.studentGradedEngagement == 4,
                                        'green4': item.studentGradedEngagement == 5 }"
                                    >
                                        <!-- <img class="scoreBar" v-if="item.studentGradedEngagement == 0" src="baseline_signal_cellular_0_bar_black_18dp.png">     -->
                                        <img class="scoreBar" v-if="item.studentGradedEngagement == 1" src="baseline_signal_cellular_0_bar_black_18dp.png">    
                                        <img class="scoreBar" v-if="item.studentGradedEngagement == 2" src="baseline_signal_cellular_1_bar_black_18dp.png">
                                        <img class="scoreBar" v-if="item.studentGradedEngagement == 3" src="baseline_signal_cellular_2_bar_black_18dp.png">
                                        <img class="scoreBar" v-if="item.studentGradedEngagement == 4" src="baseline_signal_cellular_3_bar_black_18dp.png">
                                        <img class="scoreBar" v-if="item.studentGradedEngagement == 5" src="baseline_signal_cellular_4_bar_black_18dp.png">

                                        <div v-if="item.studentGradedEngagement != 0">{{ item.studentGradedEngagement }}</div>
                                    </td>

                                    <td v-bind:class="{ 'score': true, 
                                        'gray': item.studentGradedBehaviour == 0,
                                        'yellow1': item.studentGradedBehaviour == 1,  
                                        'white2': item.studentGradedBehaviour == 2,
                                        'green2': item.studentGradedBehaviour == 3,
                                        'green3': item.studentGradedBehaviour == 4,
                                        'green4': item.studentGradedBehaviour == 5 }"
                                    >
                                        <!-- <img class="scoreBar" v-if="item.studentGradedBehaviour == 0" src="baseline_signal_cellular_0_bar_black_18dp.png">     -->
                                        <img class="scoreBar" v-if="item.studentGradedBehaviour == 1" src="baseline_signal_cellular_0_bar_black_18dp.png">    
                                        <img class="scoreBar" v-if="item.studentGradedBehaviour == 2" src="baseline_signal_cellular_1_bar_black_18dp.png">
                                        <img class="scoreBar" v-if="item.studentGradedBehaviour == 3" src="baseline_signal_cellular_2_bar_black_18dp.png">
                                        <img class="scoreBar" v-if="item.studentGradedBehaviour == 4" src="baseline_signal_cellular_3_bar_black_18dp.png">
                                        <img class="scoreBar" v-if="item.studentGradedBehaviour == 5" src="baseline_signal_cellular_4_bar_black_18dp.png">

                                        <div v-if="item.studentGradedBehaviour != 0">{{ item.studentGradedBehaviour }}</div>
                                    </td>

                                    <td v-bind:class="{ 'score': true,
                                        'gray': item.studentGradedScore == 0,
                                        'green1': item.studentGradedScore >= 61 && item.studentGradedScore <= 70,
                                        'green2': item.studentGradedScore >= 71 && item.studentGradedScore <= 80,
                                        'green3': item.studentGradedScore >= 81 && item.studentGradedScore <= 90,
                                        'green4': item.studentGradedScore >= 91,
                                        }">

                                     <div v-if="item.studentGradedScore > 0">{{ item.studentGradedScore }}</div>
                                    </td>
                                    
                                    <td class="empty"></td>

                                    <!-- DIFFERENCES -->
                                    <td v-bind:class="{ 'score': true, 
                                        'gray': item.teacherGradedDiligence == 0 || item.studentGradedDiligence == 0,
                                        'difference-more-down': item.differenceDiligence < -2 && item.teacherGradedDiligence != 0 && item.studentGradedDiligence != 0,  
                                        'difference-two-down': item.differenceDiligence == -2 && item.teacherGradedDiligence != 0 && item.studentGradedDiligence != 0,  
                                        'difference-one-down': item.differenceDiligence == -1 && item.teacherGradedDiligence != 0 && item.studentGradedDiligence != 0,
                                        'difference-one-up': item.differenceDiligence == 1 && item.teacherGradedDiligence != 0 && item.studentGradedDiligence != 0,
                                        'difference-two-up': (item.differenceDiligence == 2) && item.teacherGradedDiligence != 0 && item.studentGradedDiligence != 0,
                                        'difference-more-up': (item.differenceDiligence > 2) && item.teacherGradedDiligence != 0 && item.studentGradedDiligence != 0 
                                        }">
                                        
                                        <div v-if="item.teacherGradedDiligence != 0 && item.studentGradedDiligence != 0">
                                            {{ item.differenceDiligence }}
                                        </div>
                                    </td>

                                    <td v-bind:class="{ 'score': true, 
                                        'gray': (item.teacherGradedEngagement == 0 || item.studentGradedEngagement == 0),
                                        'difference-more-down': item.differenceEngagement < -2 && item.teacherGradedEngagement != 0 && item.studentGradedEngagement != 0,  
                                        'difference-two-down': item.differenceEngagement == -2 && item.teacherGradedEngagement != 0 && item.studentGradedEngagement != 0,  
                                        'difference-one-down': item.differenceEngagement == -1 && item.teacherGradedEngagement != 0 && item.studentGradedEngagement != 0,
                                        'difference-one-up': item.differenceEngagement == 1 && item.teacherGradedEngagement != 0 && item.studentGradedEngagement != 0,
                                        'difference-two-up': item.differenceEngagement == 2 && item.teacherGradedEngagement != 0 && item.studentGradedEngagement != 0,
                                        'difference-more-up': item.differenceEngagement > 2 && item.teacherGradedEngagement != 0 && item.studentGradedEngagement != 0 
                                        }">

                                        <div v-if="item.teacherGradedEngagement != 0 && item.studentGradedEngagement != 0">
                                            {{ item.differenceEngagement }}
                                        </div>
                                    </td>

                                    <td v-bind:class="{ 'score': true, 
                                        'gray': item.teacherGradedBehaviour == 0 || item.studentGradedBehaviour == 0,
                                        'difference-more-down': item.differenceBehaviour < -2 && item.teacherGradedBehaviour != 0 && item.studentGradedBehaviour != 0,  
                                        'difference-two-down': item.differenceBehaviour == -2 && item.teacherGradedBehaviour != 0 && item.studentGradedBehaviour != 0,  
                                        'difference-one-down': item.differenceBehaviour == -1 && item.teacherGradedBehaviour != 0 && item.studentGradedBehaviour != 0,
                                        'difference-one-up': item.differenceBehaviour == 1 && item.teacherGradedBehaviour != 0 && item.studentGradedBehaviour != 0,
                                        'difference-two-up': item.differenceBehaviour == 2 && item.teacherGradedBehaviour != 0 && item.studentGradedBehaviour != 0,
                                        'difference-more-up': item.differenceBehaviour > 2 && item.teacherGradedBehaviour != 0 && item.studentGradedBehaviour != 0
                                        }">

                                        <div v-if="item.teacherGradedBehaviour != 0 && item.studentGradedBehaviour != 0">
                                            {{ item.differenceBehaviour }}
                                        </div>
                                    </td>
                                    <td class="empty"></td>
                                </tr>
                            </tbody>     
                            <tfoot>
                                <tr>
                                    <td class="empty"></td>
                                    <td class="empty"></td>

                                    <!-- TEACHER TOTALS -->
                                    <td class="empty"></td>
                                    <td v-bind:class="{ 'score': true,
                                        'gray':  teacherDiligenceTotal == 0,
                                        'green1': teacherDiligenceTotal >= 61 && teacherDiligenceTotal <= 70,
                                        'green2': teacherDiligenceTotal >= 71 && teacherDiligenceTotal <= 80,
                                        'green3': teacherDiligenceTotal >= 81 && teacherDiligenceTotal <= 90,
                                        'green4': teacherDiligenceTotal >= 91,
                                        }">
                                    <div v-if="teacherDiligenceTotal > 0">{{ teacherDiligenceTotal }}</div>   
                                    </td>

                                    <td v-bind:class="{ 'score': true, 
                                        'gray': teacherEngagementTotal == 0,
                                        'green1': teacherEngagementTotal >= 61 && teacherEngagementTotal <= 70,
                                        'green2': teacherEngagementTotal >= 71 && teacherEngagementTotal <= 80,
                                        'green3': teacherEngagementTotal >= 81 && teacherEngagementTotal <= 90,
                                        'green4': teacherEngagementTotal >= 91,
                                        }">
                                        
                                    <div v-if="teacherEngagementTotal > 0">{{ teacherEngagementTotal }}</div>
                                    </td>

                                    <td v-bind:class="{ 'score': true, 
                                        'gray': teacherBehaviourTotal == 0,
                                        'green1': teacherBehaviourTotal >= 61 && teacherBehaviourTotal <= 70,
                                        'green2': teacherBehaviourTotal >= 71 && teacherBehaviourTotal <= 80,
                                        'green3': teacherBehaviourTotal >= 81 && teacherBehaviourTotal <= 90,
                                        'green4': teacherBehaviourTotal >= 91,
                                        }">
                                    
                                    <div v-if="teacherBehaviourTotal > 0">{{ teacherBehaviourTotal }}</div>
                                    </td>
                                    <td class="empty"></td>
                                    <td class="empty"></td>

                                    <!-- STUDENT TOTALS -->

                                    <td v-bind:class="{ 'score': true, 
                                        'gray': studentDiligenceTotal == 0,
                                        'green1': studentDiligenceTotal >= 61 && studentDiligenceTotal <= 70,
                                        'green2': studentDiligenceTotal >= 71 && studentDiligenceTotal <= 80,
                                        'green3': studentDiligenceTotal >= 81 && studentDiligenceTotal <= 90,
                                        'green4': studentDiligenceTotal >= 91,
                                        }">
                                    <div v-if="studentDiligenceTotal > 0">{{ studentDiligenceTotal }}</div>
                                    </td>

                                    <td v-bind:class="{ 'score': true, 
                                        'gray': studentEngagementTotal == 0,
                                        'green1': studentEngagementTotal >= 61 && studentEngagementTotal <= 70,
                                        'green2': studentEngagementTotal >= 71 && studentEngagementTotal <= 80,
                                        'green3': studentEngagementTotal >= 81 && studentEngagementTotal <= 90,
                                        'green4': studentEngagementTotal >= 91,
                                        }">
                                    <div v-if="studentEngagementTotal > 0">{{ studentEngagementTotal }}</div>
                                    </td>

                                    <td v-bind:class="{ 'score': true, 
                                        'gray': studentBehaviourTotal == 0,
                                        'green1': studentBehaviourTotal >= 61 && studentBehaviourTotal <= 70,
                                        'green2': studentBehaviourTotal >= 71 && studentBehaviourTotal <= 80,
                                        'green3': studentBehaviourTotal >= 81 && studentBehaviourTotal <= 90,
                                        'green4': studentBehaviourTotal >= 91,
                                        }">
                                    <div v-if="studentBehaviourTotal > 0">{{ studentBehaviourTotal }}</div>
                                    </td>
                                    <td class="empty"></td>
                                    <td class="empty"></td>
                                </tr>
                            </tfoot>         
                        </table>
                        <br>
                    </div>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-layout>
    </v-card>
</template>

<script>

import DashboardDataDownloader from './DashboardDataDownloader'
import { GetValuesForGauges, GetClassesForStudentDashboard, getTabsSettings } from '../utils/effort-tracking-api'
import { GetTeacherGraded, GetStudentGraded, GetChartData } from '../utils/effort-tracking-api'
import { getEffortScore, initialize, GetDashboardDifferences, getCompletedAndVisiblePeriods } from '../utils/effort-tracking-api'
import { getClassesForStudentDashboardByPeriodId, getValuesForGaugesByPeriodId } from '../utils/effort-tracking-api'
import { getTeacherGradedByPeriodIdFromApi, getStudentGradedByPeriodIdFromApi } from '../utils/effort-tracking-api'
import { getStudentDashboardTotals, getStudent, getDashboardDifferencesByPeriodId } from '../utils/effort-tracking-api'
import { getEffortScoreByPeriodIdFromApi, getChartDataByPeriodIdFromApi } from '../utils/effort-tracking-api'
import { getStudentDashboardTotalsByPeriodId } from '../utils/effort-tracking-api'
import { Gauge, liquidFillGaugeDefaultSettings, loadLiquidFillGauge } from '../utils/dashboardElements'
import { ScatterChart } from '../utils/dashboardElements'
const RadialProgressChart = require('radial-progress-chart');

import * as d3 from '../utils/d3.min'

export default {
    name: 'student-dashboard',
    components: {
        DashboardDataDownloader
    },
    data() {
        return {
            average: '',
            periods: [],
            studentId: this.$route.params.studentId,
            reportingPeriodId: localStorage.getItem('period-selected'),
            gaugeDiligence: 0,
            gaugeEngagement: 0,
            gaugeBehaviour: 0,
            teacherDiligenceScore: 0,
            teacherEngagementScore: 0,
            teacherbehaviourScore: 0,
            studentDiligenceScore: 0,
            studentEngagementScore: 0,
            studentBehaviourScore: 0,
            classesHeaders: [
                { text: 'Class', value: 'name', sortable: false},
                { text: 'Teacher', value: 'teacher', sortable: false }
            ],
            classesItems: [],
            teacherGradedHeaders: [
                { text: 'Diligence', value: 'diligence', sortable: false},
                { text: 'Engagement', value: 'engagement', sortable: false },
                { text: 'Behaviour', value: 'behaviour', sortable: false },
                { text: 'Score', value: 'score', sortable: false }
            ],
            teacherGradedItems: [],
            studentGradedHeaders: [
                { text: 'Diligence', value: 'diligence', sortable: false},
                { text: 'Engagement', value: 'engagement', sortable: false },
                { text: 'Behaviour', value: 'behaviour', sortable: false },
                { text: 'Score', value: 'score', sortable: false }
            ],
            studentGradedItems: [],
            chartHeaders: [
                { text: 'Class Id', value: 'classId', sortable: false},
                { text: 'Score', value: 'studentScore', sortable: false },
                { text: 'Grading Date', value: 'gradingDate', sortable: false }
            ],
            differencesItems: [],
            differencesHeaders: [
                { text: 'Diligence', value: 'differenceDiligence', sortable: false},
                { text: 'Engagement', value: 'differentEngagement', sortable: false },
                { text: 'Behaviour', value: 'differentBehaviour', sortable: false },
                { text: 'Score', value: 'differenceScore', sortable: false }
            ],
            chartItems: [],
            data: [99, 71, 78, 25, 36, 92],
            line: '',
            gauges: [],
            gradeItems: [],
            bottomNav: '',
            selectedReportingDate: null,
            noDataNotification: false,
            hasData: false,
            effortScore: 0,
            academicScore: 0,
            differenceBehaviourTotal: 0,
            differenceDiligenceTotal: 0,
            differenceEngagementTotal: 0,
            studentBehaviourTotal: 0,
            studentDiligenceTotal: 0,
            studentEngagementTotal: 0,
            teacherBehaviourTotal: 0,
            teacherDiligenceTotal: 0,
            teacherEngagementTotal: 0,
            studentName: '',
            showTables: false,
            studentEffortScore : 0,
            mainEffortControl: null,
            reportingDate: null,
            teacherDonutColor: 'rgb(79, 220, 103)',
            studentDonutColor: 'rgb(42, 205, 203)',
            diligenceLabel: '',
            engagementLabel: '',
            behaviourLabel: '',
            completeReportingPeriods: [],
            dashboardPeriodId: null
        }
    },
    watch: {
        classesItems() {
            this.populateTable();
        },
        teacherGradedItems() {
            this.populateTable();
        },
        studentGradedItems() {
            this.populateTable();
        },
        differencesItems() {
            this.populateTable();
        },
        reportingDate(date)
        {
            this.getValues(date);
        },
        bottomNav(active) {
            this.getValues(active);
        },
        dashboardPeriodId(periodId)
        {
            this.getValuesByPeriodId(periodId);
        }
    },
    methods: {
        getValuesByPeriodId(periodId) {
            if(periodId != null && periodId !== undefined) {
                this.hasData = true;
                this.getClassesByPeriodId();
                this.getGaugesByPeriodId();
                this.getTeacherGradedByPeriodId();
                this.getStudentGradedByPeriodId();
                this.getDifferencesByPeriodId();
                this.getAverageByPeriodId();
                this.getChartDataByPeriodId();
                this.getTotalsByPeriodId();
            } else {
                this.noDataNotification = true;
            }
        },
        getValues(reportingDate) {
            this.selectedReportingDate = this.formatDate(reportingDate);
            if(this.selectedReportingDate != null) {
                this.hasData = true;
                this.getClasses();
                this.getGauges();
                this.getTeacherGraded();
                this.getStudentGraded();
                this.getDifferences();
                this.getAverage();
                this.getChartData();
                this.getTotals();
            } else {
                this.noDataNotification = true;
            }
        },
        getClasses() {
            GetClassesForStudentDashboard(this.studentId, this.selectedReportingDate).then( result => {
                this.classesItems = result;
            }).catch(ex => console.log(ex));
        },
        getClassesByPeriodId() {
            getClassesForStudentDashboardByPeriodId(this.studentId, this.dashboardPeriodId).then( result => {
                this.classesItems = result;
            }).catch(ex => console.log(ex));
        },
        getGauges() {
            GetValuesForGauges(this.studentId, this.selectedReportingDate).then(result => {
                this.teacherDiligenceScore = result.teacherDiligence;
                this.teacherEngagementScore = result.teacherEngagement;
                this.teacherbehaviourScore = result.teacherBehaviour;
                this.studentDiligenceScore = result.studentDiligence;
                this.studentEngagementScore = result.studentEngagement;
                this.studentBehaviourScore = result.studentBehaviour;
                this.emptyGauges();
                this.createRadialGauges();
            }).catch(ex => console.log(ex));
        },
        getGaugesByPeriodId() {
            getValuesForGaugesByPeriodId(this.studentId, this.dashboardPeriodId).then(result => {
                this.teacherDiligenceScore = result.teacherDiligence;
                this.teacherEngagementScore = result.teacherEngagement;
                this.teacherbehaviourScore = result.teacherBehaviour;
                this.studentDiligenceScore = result.studentDiligence;
                this.studentEngagementScore = result.studentEngagement;
                this.studentBehaviourScore = result.studentBehaviour;
                this.emptyGauges();
                this.createRadialGauges();
            }).catch(ex => console.log(ex));
        },
        getTeacherGraded() {
            GetTeacherGraded(this.studentId, this.selectedReportingDate).then(result => {
                this.teacherGradedItems = result;
            }).catch(ex => console.log(ex));
        },
        getTeacherGradedByPeriodId() {
            getTeacherGradedByPeriodIdFromApi(this.studentId, this.dashboardPeriodId).then(result => {
                this.teacherGradedItems = result;
            }).catch(ex => console.log(ex));
        },
        getStudentGraded() {
            GetStudentGraded(this.studentId, this.selectedReportingDate).then(result => {
                this.studentGradedItems = result;
            }).catch(ex => console.log(ex));
        },
        getStudentGradedByPeriodId() {
            getStudentGradedByPeriodIdFromApi(this.studentId, this.dashboardPeriodId).then(result => {
                this.studentGradedItems = result;
            }).catch(ex => console.log(ex));
        },
        getDifferences() {
            GetDashboardDifferences(this.studentId, this.selectedReportingDate).then(result => {
                this.differencesItems = result;

            }).catch(ex => console.log(ex));
        },
        getDifferencesByPeriodId() {
            getDashboardDifferencesByPeriodId(this.studentId, this.dashboardPeriodId).then(result => {
                this.differencesItems = result;

            }).catch(ex => console.log(ex));
        },
        getChartData() {
            GetChartData(this.studentId, this.selectedReportingDate).then(result => {
                this.effortScore = result.teacherGradedScore;
                this.academicScore = result.academicScore;

                ScatterChart(result.teacherGradedScore, result.academicScore);
            }).catch(ex => console.log(ex));
        },
        getChartDataByPeriodId() {
            getChartDataByPeriodIdFromApi(this.studentId, this.dashboardPeriodId).then(result => {
                this.effortScore = result.teacherGradedScore;
                this.academicScore = result.academicScore;

                ScatterChart(result.teacherGradedScore, result.academicScore);
            }).catch(ex => console.log(ex));
        },
        getAverage() {
            getEffortScore(this.studentId, this.selectedReportingDate).then(result => {
                this.average = result.effortScore;
                this.studentEffortScore = result.studentEffortScore;
                if(this.mainEffortControl != null)
                {
                    this.mainEffortControl.update(result.effortScore, this.mainEffortControl);
                } else {
                    var averageControl = loadLiquidFillGauge("averageControl", this.average);
                    this.mainEffortControl = averageControl;
                }
            }).catch(ex => console.log(ex));
        },
        getAverageByPeriodId() {
            getEffortScoreByPeriodIdFromApi(this.studentId, this.dashboardPeriodId).then(result => {
                this.average = result.effortScore;
                this.studentEffortScore = result.studentEffortScore;
                if(this.mainEffortControl != null)
                {
                    this.mainEffortControl.update(result.effortScore, this.mainEffortControl);
                } else {
                    var averageControl = loadLiquidFillGauge("averageControl", this.average);
                    this.mainEffortControl = averageControl;
                }
            }).catch(ex => console.log(ex));
        },
        getTotals() {
            getStudentDashboardTotals(this.studentId, this.selectedReportingDate).then(totals => {
                this.differenceBehaviourTotal = totals.differenceBehaviourTotal;
                this.differenceDiligenceTotal = totals.differenceDiligenceTotal;
                this.differenceEngagementTotal = totals.differenceEngagementTotal;
                this.studentBehaviourTotal = totals.studentBehaviourTotal;
                this.studentDiligenceTotal = totals.studentDiligenceTotal;
                this.studentEngagementTotal = totals.studentEngagementTotal;
                this.teacherBehaviourTotal = totals.teacherBehaviourTotal;
                this.teacherDiligenceTotal = totals.teacherDiligenceTotal;
                this.teacherEngagementTotal = totals.teacherEngagementTotal;
            }).catch(ex => console.log(ex));
        },
        getTotalsByPeriodId() {
            getStudentDashboardTotalsByPeriodId(this.studentId, this.dashboardPeriodId).then(totals => {
                this.differenceBehaviourTotal = totals.differenceBehaviourTotal;
                this.differenceDiligenceTotal = totals.differenceDiligenceTotal;
                this.differenceEngagementTotal = totals.differenceEngagementTotal;
                this.studentBehaviourTotal = totals.studentBehaviourTotal;
                this.studentDiligenceTotal = totals.studentDiligenceTotal;
                this.studentEngagementTotal = totals.studentEngagementTotal;
                this.teacherBehaviourTotal = totals.teacherBehaviourTotal;
                this.teacherDiligenceTotal = totals.teacherDiligenceTotal;
                this.teacherEngagementTotal = totals.teacherEngagementTotal;
            }).catch(ex => console.log(ex));
        },
        createGauge(name, label, min, max)
        {
            var config = 
            {
                size: 180,
                label: label,
                min: undefined != min ? min : 0,
                max: undefined != max ? max : 100,
                minorTicks: 1
            };

            var range = config.max - config.min;
            config.redZones = [{ from: config.min, to: config.min + range*0.5 }];
            config.yellowZones = [{ from: config.min + range*0.5, to: config.min + range*0.85 }];
            config.greenZones = [{ from: config.min + range*0.85, to: config.max }];

            this.gauges[name] = new Gauge(name + "GaugeContainer", config);
            this.gauges[name].render();
        },
        // createGauges() {
        //     this.createGauge("diligence", "Diligence");
        //     this.createGauge("engagement", "Engagement");
        //     this.createGauge("behaviour", "Behaviour");
        // },
        // updateGauges() {
        //     for (var key in this.gauges)
        //     {
        //         var value = 0;
        //         switch (key) {
        //             case 'diligence':
        //                 value = this.gaugeDiligence;
        //             break;
        //             case 'engagement':
        //                 value = this.gaugeEngagement;
        //             break;
        //             case 'behaviour':
        //                 value = this.gaugeBehaviour;
        //             break;
        //         }
                
        //         this.gauges[key].redraw(value);
        //     }
        // },
        populateTable() {
            var results = _(this.classesItems)
                .concat(this.teacherGradedItems)
                .concat(this.studentGradedItems)
                .concat(this.differencesItems)
                .groupBy('classId')
                .map(_.spread(_.assign))
                .value();

            this.gradeItems = _.sortBy(results, ['name']);
        },
        formatDate (date) {
            if (!date) return null
            const [month, day, year] = date.split('/')
            return `${month}${day}${year}`
        },
        emptyGauges() {
            document.getElementById('radialDiligence').innerHTML = '';
            document.getElementById('radialEngagement').innerHTML = '';
            document.getElementById('radialBehaviour').innerHTML = '';
        },
        createRadialGauges(){
            if (this.behaviourLabel == '' || this.engagementLabel == '' || this.diligenceLabel == '')
            {
                getTabsSettings().then(tabs => {
                    var diligence = tabs.filter(tb => tb.name == 'DILIGENCE')[0];
                    this.diligenceLabel = (diligence.customName !== '' ) ? diligence.customName : diligence.name;

                    var engagement = tabs.filter(tb => tb.name == "ENGAGEMENT")[0];
                    this.engagementLabel = (engagement.customName !== '' ) ? engagement.customName : engagement.name;

                    var behaviour = tabs.filter(tb => tb.name == "BEHAVIOUR")[0];
                    this.behaviourLabel = (behaviour.customName !== '' ) ? behaviour.customName : behaviour.name;

                    this.createRadialGauge(this.diligenceLabel, 'radialDiligence', this.studentDiligenceScore, this.teacherDiligenceScore);
                    this.createRadialGauge(this.engagementLabel, 'radialEngagement', this.studentEngagementScore, this.teacherEngagementScore);
                    this.createRadialGauge(this.behaviourLabel, 'radialBehaviour', this.studentBehaviourScore, this.teacherbehaviourScore);

                }).catch(ex => console.log(ex));
            }
            else
            {
                this.createRadialGauge(this.diligenceLabel, 'radialDiligence', this.studentDiligenceScore, this.teacherDiligenceScore);
                this.createRadialGauge(this.engagementLabel, 'radialEngagement', this.studentEngagementScore, this.teacherEngagementScore);
                this.createRadialGauge(this.behaviourLabel, 'radialBehaviour', this.studentBehaviourScore, this.teacherbehaviourScore);
            }
        },
        createRadialGauge(label, container, studentScore, teacherScore) {
            new RadialProgressChart(`#${container}`, {
                max: 100,
                diameter: 250,
                delay: 0,
                animation: {
                    duration: 4500
                },
                round: true,
                center: [{ content: label }],
                series: [
                    { 
                        labelStart: '>',
                        value: studentScore,
                        color: [this.studentDonutColor, this.studentDonutColor]
                    }, 
                    { 
                        labelStart: '>',
                        value: teacherScore,
                        color: [this.teacherDonutColor, this.teacherDonutColor]
                    }    
                ],
                center: function() {
                    return label
                }
            });
        }
    },
    mounted() {
        this.periods = this.$store.state.periods;
        initialize().then(result => {
            getCompletedAndVisiblePeriods(this.$route.params.studentId).then(result => {  
                console.log('User completed and visible reporting periods:');
                console.log(result);

                this.completeReportingPeriods = result;

                if (result.length > 0) {
                    this.dashboardPeriodId = result[result.length -1].id;
                }

                getStudent(this.$route.params.studentId).then(student => {
                    this.studentName = `${student.lastName}, ${student.firstName}`;
                    if(result.length == 0)
                        this.noDataNotification = true;

                    getTabsSettings().then(tabs => {
                        var diligence = tabs.filter(tb => tb.name == 'DILIGENCE')[0];
                        this.diligenceLabel = (diligence.customName !== '' ) ? diligence.customName : diligence.name;

                        var engagement = tabs.filter(tb => tb.name == "ENGAGEMENT")[0];
                        this.engagementLabel = (engagement.customName !== '' ) ? engagement.customName : engagement.name;

                        var behaviour = tabs.filter(tb => tb.name == "BEHAVIOUR")[0];
                        this.behaviourLabel = (behaviour.customName !== '' ) ? behaviour.customName : behaviour.name;

                    }).catch(ex => console.log(ex));
                }).catch(ex => console.log(ex));

                
            }).catch(ex => console.log(ex));     
        });
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            if (to.meta.requiresResourceProperty && vm.$store.state.usertype == 'student')
            {
                if (parseInt(vm.$store.state.userdata.id) !== parseInt(vm.$route.params.studentId))
                {
                    vm.$route.params.studentId = vm.$store.state.userdata.id;
                    window.location.href = '#/';

                }
            }
        });
    }
}
</script>




// WEBPACK FOOTER //
// src/components/StudentDashboard.vue